import React from 'react';
import styles from './_style.module.scss';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionLengthWithUnit = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => {
    let toFormat = parseFloat(value);
    let formatted = (Number.isNaN(toFormat) ? 0 : toFormat).toFixed(
      unit === 'in' ? 4 : 2
    );
    return formatted;
  };

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  const formatValueDecimal = (e) => {
    let formattedValueRes = formattedValue(e.target.value);
    onChange({ target: { value: formattedValueRes } });
  };

  if (!isVisible) {
    return <input type="hidden" name={option.name} value={value} />;
  }

  return (
    <div className={styles.formGroup} data-widget-element="form-group">
      <label className={styles.label} data-widget-element="label">{option.presented_name}</label>
      <div className={styles.inputWrapper} data-widget-element="input-wrapper">
        <input
          type="text"
          className={`${styles.input} ${styles.inputWithSuffix}`}
          data-widget-element="input"
          data-has-suffix="true"
          value={value}
          onChange={onChange}
          onBlur={formatValueDecimal}
          readOnly={option.readonly}
          autoComplete="off"
        />
        <span className={styles.unitSuffix} data-widget-element="unit-suffix">{unit}</span>
      </div>
    </div>
  );
};

export default OptionLengthWithUnit;
